import "./image-slider.component.css"
import { useEffect, useRef, useState } from "react"
import Glide, {
  Controls,
  Breakpoints,
  Swipe,
} from "@glidejs/glide/dist/glide.modular.esm"
import "@glidejs/glide/dist/css/glide.core.css"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const ImageSliderComponent = (props) => {
  const { Items, usePadding, useIntrinsicSize } = props
  const glideRef = useRef()
  const elRef = useRef()
  const rootRef = useRef()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const el = rootRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(el)
        }
      },
      { threshold: 0.2 },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const createImageItem = (item) => {
    return (
      <div key={item.id} className="dagger-image-item glide__slide">
        <div className="dagger-image-item-image">
          <StrapiImageComponent attributes={item.attributes} sizes="(max-width: 600px) 100vw, 40vw" />
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (!useIntrinsicSize || !rootRef.current) return
    const img = rootRef.current.querySelector(".dagger-image-item-image img")
    if (!img) return

    const measure = () => {
      if (img.naturalHeight > 0) {
        rootRef.current.style.setProperty("--slide-height", `${img.offsetHeight}px`)
      }
    }

    if (img.complete) {
      measure()
    } else {
      img.addEventListener("load", measure)
    }

    const observer = new ResizeObserver(measure)
    observer.observe(img)

    return () => {
      img.removeEventListener("load", measure)
      observer.disconnect()
    }
  }, [useIntrinsicSize, Items])

  useEffect(() => {
    if (Items?.length < 1 || glideRef.current || !elRef.current) return

    glideRef.current = new Glide(elRef.current, {
      type: "carousel",
      startAt: 0,
      perView: 2.5,
      focusAt: 0,
      gap: 40,
      peek: {
        before: 0,
        after: 150,
      },
      breakpoints: {
        300: {
          perView: 1,
          peek: 0,
        },
        600: {
          perView: 1.5,
          peek: 0,
        },
        860: {
          perView: 3,
          peek: 0,
        },
      },
    }).mount({ Controls, Breakpoints, Swipe })
  }, [Items])

  return (
    <div
      ref={rootRef}
      className={
        "dagger-image-slider" +
        (usePadding ? " with-padding" : "") +
        (useIntrinsicSize ? " use-intrinsic-size" : "") +
        (isVisible ? " dagger-slide-in-visible" : " dagger-slide-in-hidden")
      }
    >
      <div className="glide" ref={elRef}>
        <div className="dagger-image-items glide__track" data-glide-el="track">
          <div className="glide__slides">
            {Items?.data?.map((i) => createImageItem(i))}
          </div>
        </div>
        <div data-glide-el="controls" className="glide-controls">
          <button data-glide-dir="<">
            <span className="prev-btn" />
          </button>
          <button data-glide-dir=">">
            <span className="next-btn" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ImageSliderComponent
